import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import useFadeIn from 'app/Components/Shared/UseFadeIn';
import ProductsAndServicesItemsBlockData from 'app/Models/Content/ProductsAndServicesItemsBlockData';
import ProductsAndServicesItemBlockData from 'Models/Content/ProductsAndServicesItemBlockData';
import React from 'react';
import {Container} from 'reactstrap';
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/swiper.scss';
import ProductsAndServicesItem from './ProductsAndServicesItem';
import {getImageProps} from 'app/utilities/ImageProps';
import SwiperCore, {Pagination} from 'swiper';

SwiperCore.use([Pagination]);

const ProductsAndServicesItemsBlock = ({data, context}: ComponentProps<ProductsAndServicesItemsBlockData>) => {
  const {fadeClass, ref} = useFadeIn();

  return (
    <div ref={ref} className={`ProductsAndServicesItemsBlock ${fadeClass}`}>
      <h2 className='ProductsAndServicesItemsBlock__title'>{data.title.value}</h2>

      <p className='ProductsAndServicesItemsBlock__subtitle'>{data.subtitle.value}</p>

      {/* mobile */}
      <Swiper
        pagination={{clickable: true}}
        spaceBetween={-20}
        slidesPerView={1.1}
        centeredSlides
        className='ProductsAndServicesItemsBlock__swiper d-sm-none'>
        {data.items.expandedValue.map((item: ProductsAndServicesItemBlockData, i) => (
          <SwiperSlide key={i}>
            <ProductsAndServicesItem item={item} image={getImageProps(item.titleAsImage, context)} />
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Desktop */}
      <Container className='ProductsAndServicesItemsBlock__items'>
        <div className='ProductsAndServicesItemsBlock__items__wrapper'>
          {data.items.expandedValue.map((item: ProductsAndServicesItemBlockData, i) => (
            <ProductsAndServicesItem key={i} item={item} image={getImageProps(item.titleAsImage, context)} />
          ))}
        </div>
      </Container>
    </div>
  );
};

export default ProductsAndServicesItemsBlock;
